<mdb-navbar SideClass="navbar navbar-expand-lg sticky-top">
    
    <!--<mdb-navbar-brand><span class="mr-3 redsaludinter">Red de salud intercongregacional</span></mdb-navbar-brand>-->
    <mdb-navbar-brand>
        <a class="nav-link waves-light" routerLink="inicio" (click)="closeMenu()"><img src="assets/img/logo-red.png" height="50" alt="Logotipo de Red de Salud Intercongregacional" class="mr-5"></a>
        
    </mdb-navbar-brand>
    
    <links #navbarLinks class="my-2 d-flex justify-content-end">
        <ul class="navbar-nav">
            <!--
            <li class="nav-item">
                <a class="nav-link waves-light" routerLink="inicio" (click)="closeMenu()">Inicio</a>
            </li>
            -->
            <li class="nav-item">
                <a class="nav-link waves-light" routerLink="quienessomos" routerLinkActive="active" (click)="closeMenu()">¿Quiénes somos?</a>
            </li>
            <li class="nav-item">
                <a class="nav-link waves-light" routerLink="quehacemos" routerLinkActive="active" (click)="closeMenu()">¿Qué hacemos?</a>
            </li>
            <li class="nav-item">
                <a class="nav-link waves-light" routerLink="voluntariado" routerLinkActive="active" (click)="closeMenu()">Voluntariado</a>
            </li>
            <li class="nav-item">
                <a class="nav-link waves-light" routerLink="sliderimpacto" routerLinkActive="active" (click)="closeMenu()">Patrocinios</a>
            </li>
            <li class="nav-item">
                <a class="nav-link waves-light" routerLink="formacion" routerLinkActive="active" (click)="closeMenu()">Formación</a>
            </li>
            <!--
            <li class="nav-item">
                <a class="nav-link waves-light p-blanco" mdbWavesEffect href="#sobremi">Donar ahora</a>
            </li>
            -->
        </ul>
    </links>
</mdb-navbar>